import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoriesService } from 'src/app/services/categori.service';

@Component({
  standalone: false,
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.css'],
})
export class ClientDetailsComponent implements OnInit {
  clientId: any;
  clientObj = {
    address: '',
    city: '',
    email: '',
    first_name: '',
    governorate: '',
    last_name: '',
    username: '',
    phone_number: '',
  };
  order_arr: any;

  showResetForm = false;
  newPassword = '';
  confirmPassword = '';
  resetLoading = false;
  resetError = '';
  resetSuccess = false;

  constructor(
    private route: ActivatedRoute,
    private routeing: Router,
    private rest: CategoriesService
  ) {}

  ngOnInit() {
    this.clientId = this.route.snapshot.paramMap.get('id');
    this.getData();
  }

  getData() {
    this.rest.clientDetails(this.clientId).subscribe((res: any) => {
      this.clientObj = res;
      this.order_arr = res.orders;
    });
  }

  orderDetails(id: any) {
    this.routeing.navigate(['main/order_details', id]);
  }

  toggleResetForm() {
    this.showResetForm = !this.showResetForm;
    this.newPassword = '';
    this.confirmPassword = '';
    this.resetError = '';
    this.resetSuccess = false;
  }

  resetPassword() {
    this.resetError = '';
    this.resetSuccess = false;

    if (this.newPassword.length < 6) {
      this.resetError = 'Password must be at least 6 characters.';
      return;
    }
    if (this.newPassword !== this.confirmPassword) {
      this.resetError = 'Passwords do not match.';
      return;
    }

    this.resetLoading = true;
    this.rest.resetClientPassword(this.clientId, this.newPassword).subscribe({
      next: () => {
        this.resetLoading = false;
        this.resetSuccess = true;
        this.newPassword = '';
        this.confirmPassword = '';
        setTimeout(() => {
          this.showResetForm = false;
          this.resetSuccess = false;
        }, 2000);
      },
      error: () => {
        this.resetLoading = false;
        this.resetError = 'Failed to reset password. Please try again.';
      },
    });
  }
}
